export enum CameraRecordingStatusHikvision {
  OK = 'OK',
  NOT_RECORDING_ON_SCHEDULE = 'NOT_RECORDING_ON_SCHEDULE',
  MANUAL_RECORDING_FAILED = 'MANUAL_RECORDING_FAILED',
  DISK_ERROR = 'DISK_ERROR',
  NETWORK_CAMERA_IS_OFFLINE = 'NETWORK_CAMERA_IS_OFFLINE',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export enum CameraHardwareStatusHikvision {
  NORMAL = 'NORMAL',
  ABNORMAL = 'ABNORMAL',
}

export enum CameraServerStatusHikvision {
  OK = 'OK',
  HI_CPU_USAGE = 'HI_CPU_USAGE',
  ERROR = 'ERROR',
}

export enum CameraServerHddStatusHikvision {
  OK = 'OK',
  HI_CPU_USAGE = 'HI_CPU_USAGE',
  ERROR = 'ERROR',
}
